<template>
    <div v-if="!loading && links.length > 0">
        <div class="echBox">
            <div class="echHeader frm-field-label">{{graphTitle}}</div>
            <vue-echarts v-bind:style="{ height: height + 'px', width: width + 'px' }"
                         :option="option" ref="chart" @click="onNodeClick" class="echChart" />
        </div>
    </div>
</template>

<script>
    //https://codesandbox.io/s/cg9c5?file=/src/components/TreeMap.vue:0-2069
    import { VueEcharts } from "vue3-echarts";
    import axios from "axios";

    const baseUri = "WebApi.asmx/api/statisticsService";
    export default {
        name: "networkGraph",
        components: {
            VueEcharts,
        },
        data() {
            return {
                selectedTopic: null,
                loading: true,
                nodes: [],
                links: [],
                option: {
                    title: {
                        text: '',
                        subtext: '',
                        top: 'top',
                        left: 'center'
                    },
                    backgroundColor: 'transparent',
                    //tooltip: {
                    //    formatter: 'Ansehen',
                    //},
                    legend: [
                        {
                            bottom: 0,
                            itemWidth: 15,
                            itemHeight: 15,
                            itemGap: 5,
                            right: 20,
                            orient: 'horizontal',
                            align: 'right',
                            overflow: 'truncate',
                            width: 800,
                            textStyle: {
                                fontSize: 9,
                                width: 200
                            },
                            selectedMode: false,
                            data: [],
                          
                        }
                    ],
                    animationDuration: 1500,
                    animationEasingUpdate: 'quinticInOut',
                    series: [
                        {
                            name: 'Topics',
                            type: 'graph',
                            layout: 'force',
                            color: ['#609fbb', '#bc594a', '#325c70', '#edc75c', '#b33873', '#b1ddcc'],
                            data: [],//graph.nodes,
                            force: {
                                initLayout: 'circular',
                                gravity: 0,
                                repulsion: 100,
                                edgeLength: 50,
                                friction: .1
                            },
                            links: [],// graph.links,
                            categories: [],// graph.categories,
                            roam: false,
                            center: [650, 125],
                            left: 'left',
                            top: 'top',
                            label: {
                                show: true,
                                position: 'right',
                                formatter: '{b}',
                                minMargin: 2,
                                overflow: 'truncate',
                                width: 400
                            },
                            labelLine: {
                                show: true,
                                length2: 5,
                                lineStyle: {
                                    color: '#bbb'
                                }
                            },
                            labelLayout: {
                                x: 320,
                                y: 0,
                                fontSize: 10,
                                moveOverlap: 'shiftY',
                            },
                            lineStyle: {
                                color: 'source',
                                curveness: 0.0
                            },
                            emphasis: {
                                focus: 'adjacency',
                                lineStyle: {
                                    width: 10
                                }
                            }
                        }
                    ]
                }

            };
        },

        created() {
            if (this.topicId > 0) {
                this.loadData(this.topicId)
            }
        },
        computed: {
            graphTitle() {
                if (this.title > '') {
                    return this.title;
                }
                else {
                    return "Ähnliche Themen";
                }
            },
            categories() {
                return this.$store.state.statisticsStore.networkByKeywordsCategories
            },
            _minSymbolSize() {
                if (this.maxSymbolSize) {
                    return this.minSymbolSize
                }
                else {
                    return 7
                }
            },
            _maxSymbolSize() {
                if (this.maxSymbolSize) {
                    return this.maxSymbolSize
                }
                else {
                    return 50
                }
            },
            _maxLevels() {
                if (this.maxLevels) {
                    return this.maxLevels
                }
                else {
                    return 1
                }
            },
            _maxSatellites() {
                if (this.maxSatellites) {
                    return this.maxSatellites
                }
                else {
                    return 20
                }
            },
        },
        props: ["width", "height", "topicId", "args", "title", "minSymbolSize", "maxSymbolSize", "maxLevels"],
        watch: {
            //nodes: function (value) {
            //    this.series.data = value
            //    this.$refs.chart.refreshOption();
            //},
            //links: function (value) {
            //    this.series.links = value
            //},
            //categories: function (value) {
            //    this.series.categories = value
            //    this.loading = false
            //},
            topicId: function (topicId) {
                this.loadData(topicId)
            }
        },
        methods: {
            onReady(instance, ECharts) {
                this.series.data = this.nodes
                this.series.links = this.links
                this.series.categories = this.categories
                console.log(instance, ECharts);
            },
            onNodeClick(params) {
                if (params.dataType == "node") {
                    this.selectedTopic = params.data
                    this.$emit('nodeClicked', { topicId: params.data.key })
                    this.loadData(params.data.key)
                }
                console.log(params)
            },
            loadData(topicId) {
                var rouId = 0
                var stgId = 0
                axios
                    .get(baseUri + '/GetNetworkByKeywords?StgId=' + stgId + '&RouId=' + rouId +
                        '&topicId=' + topicId + "&args=" + this.args + "&minSymbolSize=" + this._minSymbolSize +
                        "&maxSymbolSize=" + this._maxSymbolSize + "&maxLevels=" + this._maxLevels +
                        "&maxSatellites=" + this._maxSatellites)
                    .then(res => {
                        if (res.data.success == true) {
                            this.nodes = res.data.data.nodes
                            this.links = res.data.data.links
                            this.option.series[0].data = res.data.data.nodes
                            this.option.series[0].links = res.data.data.links
                            this.option.series[0].categories = res.data.data.categories.map(m => { return { name: m }; })
                            this.option.legend[0].data = res.data.data.categories.map(m => { return { name: m }; })
                            this.loading = false
                            if (this.$refs && this.$refs.chart) {
                                this.$refs.chart.refreshOption()
                            }
                        }
                        else {
                            alert(res.data.errorMessage)
                        }
                    })
            }
        }
    };
</script>



<style scoped>
</style>